import { atom } from "recoil";
import { AttributeConfiguration } from "../../util/models";

export const currentAttributeConfigurationsState = atom({
  key: "currentAttributeConfigurationsState", // unique ID (with respect to other atoms/selectors)
  default: [] as AttributeConfiguration[], // default value (aka initial value)
});

